import { TableV2 } from '@anytag/shared-atoms';
import { YoutubeAnalyticsShortsPayload } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerYoutubeAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerYoutubeShortsListTable } from './hooks';

export interface InfluencerYoutubeShortsListProps extends TableData<YoutubeAnalyticsShortsPayload> {
  mainSocialAccountId?: number;
  isAnalytics?: boolean;
}

export const InfluencerYoutubeShortsList = ({
  loading,
  data = [],
  isAnalytics,
  mainSocialAccountId
}: InfluencerYoutubeShortsListProps) => {
  const { columns } = useInfluencerYoutubeShortsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="57px" noTopBorderRadius hasBorder />

      <InfluencerYoutubeAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics={isAnalytics}
      />
    </>
  );
};
